import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest('post', `/api/live_discussions/${liveID}/call/end`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/endAudioConnection.js